import setFieldValue from "@iewccouk/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewccouk/Store/Reducers";
import { OwnProps, setRequestFormEffects, validateFieldBy } from "@iewccouk/Widgets/CreateAccount/FormBaseComponent";
import {
    getCountriesDataView,
    getCurrentCountries,
} from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries, {
    loadCurrentCountriesParameter,
} from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import translate from "@insite/client-framework/Translate";
import { CountryModel } from "@insite/client-framework/Types/ApiModels";
import Select from "@insite/mobius/Select";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => {
    const countriesDataView = getCountriesDataView(state, loadCurrentCountriesParameter);

    return {
        shippingCountry: state.customCreateAccountForm.fieldValues.shippingCountry,
        countries: countriesDataView,
        previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
        shouldLoadCountries: !countriesDataView.value && !countriesDataView.isLoading,
    };
};

const mapDispatchToProps = {
    setFieldValue,
    loadCurrentCountries,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const shippingCountryWidget: React.FC<Props> = ({
    shippingCountry,
    countries,
    previouslyPurchased,
    setFieldValue: widgetSetFieldValue,
    loadCurrentCountries,
    shouldLoadCountries,
}) => {
    const label = translate("Country");
    const isRequired = !previouslyPurchased || previouslyPurchased === "false";
    const hintText = "Select";
    const [shippingCountryOptions, setshippingCountryOptions] = React.useState<{ label: any; value: any }[]>([]);
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, shippingCountry, "shippingCountry", () =>
        validateFieldBy(isRequired, label, shippingCountry, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        widgetSetFieldValue({ key: "shippingCountry", value: event.target.value });
    };

    const getShippingCountryOptions = () => {
        setshippingCountryOptions(countries.value?.map?.((x: any) => ({ label: x.name, value: x.name })) || []);
    };

    React.useEffect(() => {
        if (shouldLoadCountries) {
            loadCurrentCountries();
        }
    }, [shouldLoadCountries]);

    React.useEffect(() => {
        getShippingCountryOptions();
    }, [countries]);

    return (
        <Select
            label={label}
            required={isRequired}
            value={shippingCountry || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            placeholder={hintText || ""}
        >
            <option value="" {...(isRequired && { disabled: true })}>
                {translate(hintText)}
            </option>
            {countries.value?.map((shippingCountry: CountryModel) => (
                <option key={shippingCountry.id} value={shippingCountry.name}>
                    {shippingCountry.name}
                </option>
            ))}
        </Select>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(shippingCountryWidget);
